module.exports = __webpack_public_path__ + "img/space-ship.945975b0.png";